function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AVLive = /*#__PURE__*/function () {
  function AVLive() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, AVLive);
    _defineProperty(this, "sendViewingEvent", function () {
      $.ajax({
        method: 'post',
        url: '/viewing',
        data: {
          tag: window.streaming_tag
        }
      }).then(function (response) {
        window.viewing_id = response.id;
      });
    });
    _defineProperty(this, "sendStillViewingEvent", function (interval) {
      $.ajax({
        method: 'post',
        url: '/still-viewing',
        data: {
          id: window.viewing_id,
          "int": interval
        }
      });
    });
    var defaults = {
      room_toggler_id: milc_conf.room_toggler,
      video_box_id: milc_conf.video_container,
      room_box_id: milc_conf.room_box,
      chat_container_id: milc_conf.container,
      responsive_container_id: milc_conf.responsive_container,
      av_live_id: milc_conf.av_live,
      av_lang: milc_conf.av_lang,
      av_player: milc_conf.av_player,
      av_player_id: milc_conf.video_player_container,
      av_live_iframes: milc_conf.live_iframes,
      teleport_button_id: milc_conf.teleport_button,
      teleport_overlay_id: milc_conf.teleport_overlay,
      av_switch_iframe_lang: milc_conf.switch_iframe_lang,
      playerInitialized: false,
      forced_iframe: milc_conf.forced_iframe
    };
    this.options = Object.assign({}, defaults, options);
    var is_live = this.initialize();
    if (!is_live) return false;
    this.initializeUI();
    this.setPlayer(this.options.av_lang, this.options.av_player);
    return true;
  }
  _createClass(AVLive, [{
    key: "initialize",
    value: function initialize() {
      this.$av_live = $(this.options.av_live_id);
      this.$room_toggler = $(this.options.room_toggler_id);
      this.$video_box = $(this.options.video_box_id);
      this.$room_box = $(this.options.room_box_id);
      this.$chat_container = $(this.options.chat_container_id);
      this.$responsive_container = $(this.options.responsive_container_id);
      this.$teleport_button = $(this.options.teleport_button_id);
      this.$room_box_title = $("#room-box-title");
      this.$switch_iframe_lang = $(this.options.av_switch_iframe_lang);
      return this.$av_live.length;
    }
  }, {
    key: "initializeUI",
    value: function initializeUI() {
      var self = this;
      if (this.$room_toggler.length) {
        this.initRoomToggler();
      }
      if (!this.$chat_container.hasClass('no-resize') && this.$av_live.data('av-theme') === 'live-aside') {
        window.onresize = function () {
          self.chatResize();
        };
        setTimeout(function () {
          self.chatResize();
        }, 300);
      }
      if (this.$switch_iframe_lang.length) {
        $(this.$switch_iframe_lang).on('click', function () {
          if (!$(this).hasClass('lang-active')) {
            var lang = $(this).attr('data-lang');
            self.setIframePlayer(lang);
            $(this).addClass('lang-active');
            $(this).parent().siblings().find('.button-switch-lang').removeClass('lang-active');
          }
        });
      }
      if (this.$teleport_button.length) {
        this.initTeleport();
      }
    }
  }, {
    key: "initTeleport",
    value: function initTeleport() {
      var $overlay = $(this.options.teleport_overlay_id);
      this.$teleport_button.on('click', function (e) {
        var $this = $(this);
        console.log('click');

        // setup overlay
        $overlay.removeClass('d-none');
        $this.prop('disabled', 'disabled');
        setTimeout(function () {
          $overlay.addClass('d-none');
        }, 5000);
        window.$milcConnector.joined(false).then(function () {
          console.log('done');
          $overlay.addClass('d-none');
          $this.removeAttr('disabled');
        });
      });
    }
  }, {
    key: "initRoomToggler",
    value: function initRoomToggler() {
      var self = this;
      this.$room_toggler.on('click', function () {
        if (self.isChatOpen()) {
          self.closeChat();
        } else {
          self.openChat();
        }
      });
    }
  }, {
    key: "chatResize",
    value: function chatResize() {
      if (this.$responsive_container.length === 0) {
        return;
      }
      //const self = AVLive ? AVLive : this
      //return;

      var vp = this.getViewport();
      var h = 'auto';
      var bh = 0;
      var gap = this.$room_box_title.length ? this.$room_box_title.outerHeight() : 0;
      console.log('gap', gap, this.$responsive_container.outerHeight());
      if (vp.x >= 992) {
        h = this.$responsive_container.outerHeight();
        h = h - gap - 50;
      } else {
        h = 650;
      }

      //h = h - 32;	// remove vertical padding

      //bh = bh + 15;	// remove vertical padding
      // console.log('resize', this, h);
      // console.log('chat_container', this.$chat_container.length);
      this.$chat_container.height(h);
    }
  }, {
    key: "isChatOpen",
    value: function isChatOpen() {
      return this.$av_live.hasClass('chat-open');
    }
  }, {
    key: "closeChat",
    value: function closeChat() {
      this.$av_live.removeClass('chat-open').addClass('chat-closed');
      this.$chat_container.slideUp('medium');
    }
  }, {
    key: "openChat",
    value: function openChat() {
      this.$av_live.removeClass('chat-closed').addClass('chat-open');
      this.$chat_container.slideDown('medium');
    }
  }, {
    key: "setIframePlayListener",
    value: function setIframePlayListener() {
      if (window.addEventListener) {
        window.addEventListener("message", onMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", onMessage, false);
      }
      var sendViewingEventFn = this.sendViewingEvent;
      var sendStillViewingEventFn = this.sendStillViewingEvent;
      function onMessage(event) {
        var data = event.data;
        if (data.message === 'play') {
          console.log('iframe play');
          sendViewingEventFn();
        } else if (data.message === 'still-play') {
          console.log('iframe still-play');
          sendStillViewingEventFn(data.interval);
        }
      }
    }
  }, {
    key: "setIframePlayer",
    value: function setIframePlayer(lang) {
      //console.debug('setIframePlayer switch', lang, !!this.options.av_live_iframes[lang])

      if (this.options.forced_iframe) {
        this.$video_box.html(this.options.forced_iframe);
      } else if (this.options.av_live_iframes[lang]) {
        this.$video_box.html(this.options.av_live_iframes[lang]);
      }
    }
  }, {
    key: "setVideoJSPlayer",
    value: function setVideoJSPlayer(lang) {
      var playerID = this.options.av_player_id ? this.options.av_player_id.substr(1) : '';
      console.debug('setVideoJSPlayer id', playerID);
      if (this.playerInitialized) {
        videojs(playerID).dispose();
      }
      console.debug('setVideoJSPlayer switch', lang, !!this.options.av_live_iframes[lang]);
      if (this.options.av_live_iframes[lang]) {
        this.$video_box.html(this.options.av_live_iframes[lang]);
      }
      var player = videojs(playerID);
      player.maxQualitySelector({
        'defaultQuality': 2
      });
      player.on('play', this.sendViewingEvent);
      player.on('fullscreenchange', function () {
        $(window).trigger('resize');
      });
    }
  }, {
    key: "setPlayer",
    value: function setPlayer(lang, player) {
      console.debug('setPlayer', player, lang);
      switch (player) {
        case 'videojs':
          this.setVideoJSPlayer(lang);
          break;
        default:
          this.setIframePlayListener();
          this.setIframePlayer(lang);
          break;
      }
      this.playerInitialized = true;
    }
  }, {
    key: "changeRoomStatus",
    value: function changeRoomStatus(status) {
      console.debug('changeRoomStatus', status);
      if (status.mode == 'q&a') {} else if (status.mode == 'poll') {}
    }
  }, {
    key: "changeIframe",
    value: function changeIframe(destination) {
      console.debug('change_iframe_callback', destination, this.options.video_box_id);
      this.$video_box.html('');
      var self = this;
      postscribe(this.options.video_box_id, destination.html, function () {
        $(window).trigger('resize');
        if (destination.subtype === 'streaming') {
          self.setPlayer('', self.options.av_player);
        }
      });
    }
  }, {
    key: "getViewport",
    value: function getViewport() {
      var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight || e.clientHeight || g.clientHeight;
      return {
        x: x,
        y: y
      };
    }
  }]);
  return AVLive;
}();
export { AVLive as default };